/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ITriageSubtitleEntry } from '../getCollectionTriageNext/get-collection-triage-next-response';
import {
  triageChallengeSchema,
  triageClipSchema,
} from '../getCollectionTriageNext/get-collection-triage-next-response';

export const triageClipV2Schema = triageClipSchema.extend({
  verticalFileSizeKb: z.number().nullable(),
});

export const triageItemV2Schema = z
  .object({
    clip: triageClipV2Schema,
    challenge: triageChallengeSchema,
  })
  .nullable();

export const getCollectionTriageNextV2ResponseSchema = createApiResponseSchema(
  triageItemV2Schema,
) as z.ZodSchema<IAPI<ITriageItemV2 | null>>;

export interface ITriageClipV2 {
  id: number;
  baseLocalPath: string | null;
  verticalLocalPath?: string | null;
  basePath: string | null;
  verticalPath: string | null;
  verticalRejected: number;
  cropStatus: string | null;
  vaultPath: string | null;
  startMs: number | null;
  endMs: number | null;
  triageAction: string | null;
  rejectionReason: string | null;
  fileSizeKb: number | null;
  verticalFileSizeKb: number | null;
  subtitleEntries: ITriageSubtitleEntry[] | null;
}

export interface ITriageChallengeV2 {
  id: number;
  title: string | null;
  originalTitle: string | null;
  definition: string | null;
  definitionSimple: string | null;
  published: number;
  triageStatus: string | null;
  type: string | null;
  cefrLevel: string | null;
  confidenceScore: number | null;
  qualityScore: number | null;
  suggestedForm: string | null;
  qualityReasoning: string | null;
  totalClips: number;
  approvedClips: number;
}

export interface ITriageItemV2 {
  clip: ITriageClipV2;
  challenge: ITriageChallengeV2;
}

export type IGetCollectionTriageNextV2Response = IAPI<ITriageItemV2 | null>;
